/**
 * @name star-minus
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMThoNiIgLz4KICA8cGF0aCBkPSJNMTcuNjg4IDE0YTIuMSAyLjEgMCAwIDEgLjQxNi0uNTY4bDMuNzM2LTMuNjM4YS41My41MyAwIDAgMC0uMjk0LS45MDVsLTUuMTY2LS43NTVhMi4xIDIuMSAwIDAgMS0xLjU5NS0xLjE2bC0yLjMxLTQuNjhhLjUzLjUzIDAgMCAwLS45NS4wMDFMOS4yMTYgNi45NzRhMi4xIDIuMSAwIDAgMS0xLjU5NyAxLjE2bC01LjE2NS43NTVhLjUzLjUzIDAgMCAwLS4yOTQuOTA2bDMuNzM2IDMuNjM3YTIuMSAyLjEgMCAwIDEgLjYxMSAxLjg3OWwtLjg4IDUuMTM5YS41My41MyAwIDAgMCAuNzY5LjU2bDQuNjE3LTIuNDI4LjAyNy0uMDE0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/star-minus
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const StarMinus: string = `
<svg
  class="lucide lucide-star-minus"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M15 18h6" />
  <path d="M17.688 14a2.1 2.1 0 0 1 .416-.568l3.736-3.638a.53.53 0 0 0-.294-.905l-5.166-.755a2.1 2.1 0 0 1-1.595-1.16l-2.31-4.68a.53.53 0 0 0-.95.001L9.216 6.974a2.1 2.1 0 0 1-1.597 1.16l-5.165.755a.53.53 0 0 0-.294.906l3.736 3.637a2.1 2.1 0 0 1 .611 1.879l-.88 5.139a.53.53 0 0 0 .769.56l4.617-2.428.027-.014" />
</svg>
`;

export default StarMinus;
